import { Outlet, useLocation } from "react-router-dom"
import { Header } from "./Header"
import { Footer } from "./Footer"
import { Sidebar } from "./Sidebar"
import { useIsMobile } from "@/hooks/useMobile"

export function Layout() {
  const isMobile = useIsMobile()
  const location = useLocation()
  
  // Detect if we're on a meeting detail page (needs full width)
  const isMeetingDetailPage = location.pathname.match(/^\/app\/meetings\/[^/]+$/)

  return (
    <div className="min-h-screen gradient-background relative">
      {/* Animated background blobs for misty effect */}
      <div className="fixed inset-0 w-full h-full pointer-events-none z-0 overflow-hidden">
        {/* Base gradient layer */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-slate-100 to-indigo-50 dark:from-slate-900 dark:via-slate-800 dark:to-indigo-950"></div>
        
        {/* Animated Blobs */}
        <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-purple-300 dark:bg-purple-900/40 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-3xl opacity-20 dark:opacity-30 animate-blob"></div>
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-cyan-300 dark:bg-cyan-900/40 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-3xl opacity-20 dark:opacity-30 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-[-20%] left-[20%] w-[500px] h-[500px] bg-indigo-300 dark:bg-indigo-900/40 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-3xl opacity-20 dark:opacity-30 animate-blob animation-delay-4000"></div>
        
        {/* Noise texture overlay */}
        <div className="absolute inset-0 bg-noise opacity-50"></div>
      </div>
      
      <div className="relative z-10">
        <Header isMobile={isMobile} />
        <div className="flex h-[calc(100vh-4rem)] pt-16">
          {!isMobile && <Sidebar />}
          <main className={`flex-1 overflow-y-auto ${isMeetingDetailPage ? 'p-4' : 'p-6'}`}>
            {isMeetingDetailPage ? (
              <Outlet />
            ) : (
              <div className="mx-auto max-w-7xl">
                <Outlet />
              </div>
            )}
          </main>
        </div>
        <Footer />
      </div>
    </div>
  )
}
